import { render, staticRenderFns } from "./ConfirmArea.vue?vue&type=template&id=2aaa6ce7&scoped=true&"
import script from "./ConfirmArea.vue?vue&type=script&lang=js&"
export * from "./ConfirmArea.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmArea.vue?vue&type=style&index=0&id=2aaa6ce7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aaa6ce7",
  null
  
)

export default component.exports